import React, { useState, useEffect } from 'react';
import { Modal, Button, Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { postUpdateUserProfileRepository } from '../../../repository/mytm/user/userMeRepository';
import { USER_PROFILE } from '../../../constants/define/translation';

const UpdateUserCountryModal = ({ visible, onClose, countries, userId, onRefresh, defaultCountry }: any) => {
  const { t } = useTranslation(USER_PROFILE);
  const [selectedCountry, setSelectedCountry] = useState<string | undefined>(defaultCountry);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelectedCountry(defaultCountry); // Set default value when modal opens
  }, [defaultCountry]);

  const handleSave = async () => {
    if (!selectedCountry) {
      message.error(t('validate.selectCountry'));
      return;
    }

    setLoading(true);
    try {
      await postUpdateUserProfileRepository(userId, { userCountry: selectedCountry });
      message.success(t('message.userCountry'));
      onRefresh(); // Refresh data after successful update
      onClose(); // Close the modal
    } catch (error: any) {
      message.error(t('err.message.updateCountry'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Update User"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" loading={loading} onClick={handleSave}>
          Save
        </Button>,
      ]}
    >
      <div style={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p style={{ marginRight: 20, marginTop: 12, fontWeight: 600 }}>Select country:</p>
        <Select
          placeholder="Select a country"
          style={{ width: '50%' }}
          options={countries}
          value={selectedCountry}
          onChange={value => setSelectedCountry(value)}
        />
      </div>
    </Modal>
  );
};

export default UpdateUserCountryModal;
